import { schema } from 'normalizr'
import { List, Map } from 'immutable'

import Model from './model'

class Budget extends Model({
  acceptsInstallment: undefined,
  acceptsWarranty: undefined,
  additionalInfo: undefined,
  additionalTakeRate: undefined,
  additionalTakeRatePerc: undefined,
  agencyCompletionPercentage: undefined,
  anotherReasonForRefusal: undefined,
  approved: undefined,
  budgetApprovalConfirmationPictures: List(),
  blockFinanceTransfers: undefined,
  budgetItems: List(),
  budgetPayer: undefined,
  budgetParent: undefined,
  budgetPictures: List(),
  budgetResolution: List(),
  cancelServiceOrder: undefined,
  comfortableAmount: undefined,
  counterProposalAccepted: undefined,
  createdAt: undefined,
  coverageValue: undefined,
  confidentialInfo: undefined,
  datetimeExecutionBudgetApproved: undefined,
  datetimeExecutionScheduled: null,
  deadlineStart: undefined,
  diagnosis: undefined,
  discount: undefined,
  displacementValue: undefined,
  estimatedTradesmanTotal: undefined,
  executionProof: undefined,
  executionDue: undefined,
  id: undefined,
  installments: undefined,
  invoice: undefined,
  isOriginal: undefined,
  isRevised: undefined,
  laborValue: undefined,
  oldTradesmanPrice: undefined,
  observations: undefined,
  personPaying: undefined,
  personPayingCpf: undefined,
  personPayingEmail: undefined,
  personPayingName: undefined,
  personPayingWhatsapp: undefined,
  paymentLink: undefined,
  paymentLinks: List(),
  priceAgency: undefined,
  priceRefera: undefined,
  priceTotal: undefined,
  proposedSolution: undefined,
  proposeOpened: undefined,
  reasonForRefusal: undefined,
  referaCompletionPercentage: undefined,
  referaRegularTax: undefined,
  referaRegularTaxPercentage: undefined,
  requestedChangeServiceProvider: undefined,
  refused: undefined,
  released: undefined,
  revenueShare: undefined,
  serviceOrder: undefined,
  stage: undefined,
  status: undefined,
  totalPriceTradesman: undefined,
  totalPrice: undefined,
  tradesman: Map(),
  variationAccepted: undefined,
  visitHappened: undefined,
  visitHappenedTemp: undefined,
  warrantyMonths: undefined,
  warrantyValue: undefined,
  personPayingAuth: undefined,
  reasonDevolution: undefined,
  refusalMoreDetails: undefined,
  reasonForCancelServiceOrder: undefined,
  withholdingTax: undefined,
  withholdingTaxValue: undefined,
  financialIncome: undefined,
  financialIncomeValue: undefined,
  maxInstallmentsAllowed: undefined,
  maxTaxAllowed: undefined,
  priceServiceProvider: undefined,
  totalPriceServiceProvider: undefined,
  liquidValue: undefined,
  pdfModelId: undefined,
  secondary: undefined,
  isSimplified: undefined,
  extendedWarranty: undefined,
  extendedWarrantyValue: undefined,
  additionalWarrantyMonths: undefined,
}) {}

const budgetNewSchema = new schema.Entity(
  'results',
  {},
  {
    processStrategy: entity => new Budget(entity),
  }
)

const budgetSchema = [budgetNewSchema]

export { budgetSchema, Budget as default }
